import { createRouter, createWebHistory } from "vue-router";
import { levelEnum } from "@/utilities/enum";
import {
  getDefaultRouteForRole,
  resolveUserRoleFromSession,
} from "@/router/routeAccess";
import InfoKontraktor from "../pages/InfoKontraktorPage.vue";
import Penghargaan from "../pages/PenghargaanPage.vue";
import TentangBIB from "../pages/TentangBIBPage.vue";
import DetailKontraktor from "../pages/DetailKontraktorPage.vue";
import LoginPage from "../pages/auth/LoginPage.vue";
import DashboardPage from "@/pages/dashboards/DashboardPage.vue";
import DashboardNewPage from "@/pages/dashboards/DashboardNewPage.vue";
import SideBar from "@/components/SideBar.vue";
import ProfilePage from "../pages/profile/ProfilePage.vue";
import EditProfilePage from "../pages/profile/EditProfilePage.vue";
import AddSubkontraktorPage from "../pages/profile/AddSubkontraktorPage.vue";
import SubkontraktorPage from "../pages/profile/SubkontraktorPage.vue";
import ApprovalSioPage from "@/pages/sio/ApprovalSioPage.vue";
import PergantianSioPage from "@/pages/sio/PergantianSioPage.vue";
import UpdateDataSioPage from "@/pages/sio/UpdateDataSioPage.vue";
import DokumenPersyaratanPengajuanPJO from "@/pages/sio/DokumenPersyaratanPengajuanPJO.vue";
import PraPresentasiPJPBaruPage from "@/pages/sio/PraPresentasiPJPBaruPage.vue";
import FormSuratPermohonanPengesahanPJO from "@/pages/sio/FormSuratPermohonanPengesahanPJO.vue";
import KontrakPage from "@/pages/kontrak/KontrakPage.vue";
import AddKontrakPage from "@/pages/kontrak/AddKontrakPage.vue";
import EditKontrakPage from "@/pages/kontrak/EditKontrakPage.vue";
import ProfileKontraktorPreviewPage from "@/pages/md-kontraktor/ProfileKontraktorPreviewPage.vue";

import MUserListInternalPage from "@/pages/md-users-internal/MUserListInternalPage.vue";
import AddKontraktorPage from "@/pages/md-kontraktor/AddKontraktorPage.vue";
import DetailAddKontraktorPage from "@/pages/md-kontraktor/DetailAddKontraktorPage.vue";
import MdKontraktorPage from "@/pages/md-kontraktor/MdKontraktorPage.vue";
import MUserListKontraktorPage from "@/pages/md-users-kontraktor/MUserListKontraktorPage.vue";
import DetailProfileKontraktorPage from "@/pages/md-kontraktor/DetailProfileKontraktorPage.vue";
import KontrakDetailPage from "@/pages/kontrak/KontrakDetailPage.vue";
import FormDaftarRiwayatHidup from "@/pages/sio/FormDaftarRiwayatHidup.vue";
import FormSuratPernyataanCalonPJO from "@/pages/sio/FormSuratPernyataanCalonPJO.vue";
import FormSuratPernyataanKebenaranDokumen from "@/pages/sio/FormSuratPernyataanKebenaranDokumen.vue";
import FormSuratPernyataanDukungan from "@/pages/sio/FormSuratPernyataanDukungan.vue";
import viewEditKontraktorPage from "@/pages/md-kontraktor/viewEditKontraktorPage.vue";
import verifikasiDataKontraktorPage from "@/pages/md-kontraktor/verifikasiDataKontraktorPage.vue";
import verifikasiDataKontraktorPenerbitanPage from "@/pages/md-kontraktor/verifikasiDataKontraktorPenerbitanPage.vue";
import Form1View from "@/pages/sio/admin_view/form1View.vue";
import Form2View from "@/pages/sio/admin_view/form2View.vue";
import Form3View from "@/pages/sio/admin_view/form3View.vue";
import Form4View from "@/pages/sio/admin_view/form4View.vue";
import Form5View from "@/pages/sio/admin_view/form5View.vue";
import lihatDokumenSIO from "@/pages/sio/admin_view/lihatDokumenSIO.vue";
import printDokumenSIO from "@/pages/sio/admin_view/printDokumenSIO.vue";
import PrintFormSuratPernyataanCalonPJO from "@/pages/sio/PrintFormSuratPernyataanCalonPJO.vue";
import PrintFormSuratPernyataanKebenaranDokumen from "@/pages/sio/PrintFormSuratPernyataanKebenaranDokumen.vue";
import PrintFormSuratPernyataanDukungan from "@/pages/sio/PrintFormSuratPernyataanDukungan.vue";
import PreviewKontraktorSioPage from "@/pages/sio/PreviewKontraktorSioPage.vue";
import PenjadwalanPresentasi from "@/pages/sio/PenjadwalanPresentasi.vue";
import PenilaianPresentasi from "@/pages/sio/PenilaianPresentasi.vue";
import ResumePenilaian from "@/pages/sio/penilaian/resumePenilaian.vue";
import NCPage from "@/pages/sio/NCPage.vue";
// import printDokumenForm1 from "@/pages/sio/admin_view/printDokumenForm1.vue";
// import printDokumenForm2 from "@/pages/sio/admin_view/printDokumenForm2.vue";

import materiAspek from "@/pages/sio/penilaian/materi/aspekMateri.vue";
import materiAspekTeknikOperasional from "@/pages/sio/penilaian/materi/aspekTeknikOperasional.vue";
import materiAspekKeselamatanPertambangan from "@/pages/sio/penilaian/materi/aspekKeselamatanPertambangan.vue";
import materiAspekSmkp from "@/pages/sio/penilaian/materi/aspekSmkp.vue";
import materiAspekPengelolaanLingkunganHidup from "@/pages/sio/penilaian/materi/aspekPengelolaanLingkunganHidup.vue";
import materiAspekKonservasi from "@/pages/sio/penilaian/materi/aspekKonservasi.vue";
import materiAspekStandarisasiUsahaJaya from "@/pages/sio/penilaian/materi/aspekStandarisasiUsahaJaya.vue";
import materiAspekImprovement from "@/pages/sio/penilaian/materi/aspekImprovement.vue";

import teknisAspek from "@/pages/sio/penilaian/teknis/aspekTeknis.vue";
import teknisAspekTeknikOperasional from "@/pages/sio/penilaian/teknis/aspekTeknikOperasional.vue";
import teknisAspekKeselamatanPertambangan from "@/pages/sio/penilaian/teknis/aspekKeselamatanPertambangan.vue";
import teknisAspekSmkp from "@/pages/sio/penilaian/teknis/aspekSmkp.vue";
import teknisAspekPengelolaanLingkunganHidup from "@/pages/sio/penilaian/teknis/aspekPengelolaanLingkunganHidup.vue";
import teknisAspekKonservasi from "@/pages/sio/penilaian/teknis/aspekKonservasi.vue";
import teknisAspekStandarisasiUsahaJaya from "@/pages/sio/penilaian/teknis/aspekStandarisasiUsahaJaya.vue";
import teknisAspekImprovement from "@/pages/sio/penilaian/teknis/aspekImprovement.vue";
import PresentasiPjoNC from "@/pages/penilaian-pjo/nc-presentasi/PresentasiPjoNC.vue";
import FormSuratPengesahanPenunjukanPJO from "@/pages/sio/FormSuratPengesahanPenunjukanPJO.vue";
import ImkpPage from "@/pages/imkp/ImkpPage.vue";
import ApprovalImkpPage from "@/pages/imkp/ApprovalImkpPage.vue";
import DetailImkpPage from "@/pages/imkp/DetailImkpPage.vue";

import ReportSioPage from "@/pages/report/ReportSioPage.vue";
import historyPenilaian from "@/pages/sio/penilaian/historyPenilaian.vue";
import MaintenancePage from "@/components/MaintenancePage.vue";
import VerifikasiDataImkpPage from "@/pages/imkp/VerifikasiDataImkpPage.vue";
import PreviewImkpPage from "@/pages/imkp/PreviewImkpPage.vue";
import DashboardPageEsg from "@/pages/dashboards/DashboardPageEsg.vue";
import EsgReportPage from "@/pages/esg/EsgReportPage.vue";
import EsgDetailPage from "@/pages/esg/EsgDetailPage.vue";
import MasterDataFuelPage from "@/pages/master-data/fuel/MasterDataFuelPage.vue";
import MasterDataElectricPage from "@/pages/master-data/electric/MasterDataElectricPage.vue";
import MasterDataRenewableEnergyPage from "@/pages/master-data/renewable-energy/MasterDataRenewableEnergyPage.vue";
import DetailDashboardEsgPage from "@/pages/dashboards/DetailDashboardEsgPage.vue";
import MasterDataPowerAvailablePage from "@/pages/master-data/power-available/MasterDataPowerAvailablePage.vue";
import SettingPage from "@/pages/setting/SettingPage.vue";

let routes = [
  {
    path: "/infokontraktor",
    name: "infokontraktor",
    component: InfoKontraktor,
    meta: { title: "Info Kontraktor - Sini Saja", requiresAuth: false },
  },
  {
    path: "/penghargaan",
    name: "penghargaan",
    component: Penghargaan,
    meta: { title: "Penghargaan - Sini Saja", requiresAuth: false },
  },
  {
    path: "/tentangbib",
    name: "tentangbib",
    component: TentangBIB,
    meta: { title: "Tentang - Sini Saja", requiresAuth: false },
  },
  {
    path: "/detailkontraktor/:id",
    name: "detailkontraktor",
    component: DetailKontraktor,
    meta: { title: "Kontraktor Detail - Sini Saja", requiresAuth: false },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: {
      title: "Login - Sini Saja",
      requiresAuth: false,
    },
  },
  {
    path: "/login/isafe",
    name: "LoginISafe",
    component: LoginPage,
    meta: {
      title: "Login - Sini Saja",
      requiresAuth: false,
    },
  },
  {
    path: "/dashboard",
    component: DashboardNewPage,
    meta: {
      title: "Dashboard - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.KONTRAKTOR,
        levelEnum.REPORTER,
        levelEnum.ENVIRONMENT,
        levelEnum.OHS,
        levelEnum.ISAFE,
      ],
    },
  },
  {
    path: "/dashboard-nc",
    component: () => import("@/pages/dashboards/DashboardNCPage.vue"),
    meta: {
      title: "Dashboard NC - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/manajement/kontraktor",
    component: MdKontraktorPage,
    meta: {
      title: "MD Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },

  {
    path: "/manajement/kontraktor/users",
    component: MUserListKontraktorPage,
    meta: {
      title: "MD User Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/manajement/internal/users",
    component: MUserListInternalPage,
    meta: {
      title: "MD User Internal - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/manajement/add-kontraktor",
    component: AddKontraktorPage,
    meta: {
      title: "Tambah Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/manajement/detail-add-kontraktor/:id",
    component: DetailAddKontraktorPage,
    meta: {
      title: "Tambah Kontraktor Detail - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/profile",
    component: ProfilePage,
    meta: {
      title: "Profile - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/editprofile",
    component: EditProfilePage,
    meta: {
      title: "Edit Profile - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/editprofile/:id",
    component: viewEditKontraktorPage,
    meta: {
      title: "Edit Profile Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/verifikasiDataKontraktor/:id",
    component: verifikasiDataKontraktorPage,
    meta: {
      title: "Verifikasi Data Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/verifikasiDataKontraktorPenerbitan/:id/:kontraktorId",
    component: verifikasiDataKontraktorPenerbitanPage,
    meta: {
      title: "Verifikasi Data Penerbitan - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/subkontraktor/:id",
    component: SubkontraktorPage,
    meta: {
      title: "Sub Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR, levelEnum.ADMIN],
    },
  },
  {
    path: "/profileKontraktor/:id",
    component: DetailProfileKontraktorPage,
    meta: {
      title: "Profile Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR, levelEnum.ADMIN],
    },
  },
  {
    path: "/profileKontraktor/preview-sio/:id/:kontraktorId",
    component: PreviewKontraktorSioPage,
    meta: {
      title: "Preview Kontraktor CoC - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR, levelEnum.ADMIN],
    },
  },
  {
    path: "/addsubkontraktor",
    component: AddSubkontraktorPage,
    meta: {
      title: "Tambah Sub Kontraktor - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/kontrak",
    component: KontrakPage,
    meta: {
      title: "Kontrak - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR, levelEnum.ADMIN],
    },
  },
  {
    path: "/kontrak/detail/:id",
    component: KontrakDetailPage,
    meta: {
      title: "Kontrak Detail - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR, levelEnum.ADMIN],
    },
  },
  {
    path: "/addkontrak",
    component: AddKontrakPage,
    meta: {
      title: "Tambah Kontrak - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/editkontrak/:id",
    component: EditKontrakPage,
    meta: {
      title: "Edit Kontrak - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/approval-sio",
    component: ApprovalSioPage,
    meta: {
      title: "Approval CoC - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/pergantian-sio",
    component: PergantianSioPage,
    meta: {
      title: "Pergantian CoC - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/update-data-sio",
    component: UpdateDataSioPage,
    meta: {
      title: "Update Data CoC - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN, levelEnum.ISAFE],
    },
  },
  {
    path: "/dokumenpersyaratanpengajuanpjo/:id/:kontraktorId",
    component: DokumenPersyaratanPengajuanPJO,
    meta: {
      title: "Dokumen Persyaratan PJO - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.KONTRAKTOR,
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/sio",
    component: PraPresentasiPJPBaruPage,
    meta: {
      title: "Pra Presentasi PJP Baru - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/formSuratPermohonanPengesahanPJO",
    component: FormSuratPermohonanPengesahanPJO,
    meta: {
      title: "Surat Permohonan Pengesahan PJO - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/formDaftarRiwayatHidup",
    component: FormDaftarRiwayatHidup,
    meta: {
      title: "Daftar Riwayat Hidup - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/formSuratPernyataanCalonPJO",
    component: FormSuratPernyataanCalonPJO,
    meta: {
      title: "Surat Pernyataan Calon PJO - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/printFormSuratPernyataanCalonPJO",
    component: PrintFormSuratPernyataanCalonPJO,
    meta: {
      title: "Surat Pernyataan Calon PJO - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
    children: [
      {
        path: "",
        name: "printFormSuratPernyataanCalonPJO",
        components: {
          default: DashboardPage,
          sidebar: SideBar,
        },
      },
    ],
  },
  {
    path: "/printFormSuratPernyataanKebenaranDokumen",
    component: PrintFormSuratPernyataanKebenaranDokumen,
    meta: {
      title: "Surat Pernyataan Kebenaran Dokumen - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
    children: [
      {
        path: "",
        name: "printFormSuratPernyataanKebenaranDokumen",
        components: {
          default: DashboardPage,
          sidebar: SideBar,
        },
      },
    ],
  },
  {
    path: "/printFormSuratPernyataanDukungan",
    component: PrintFormSuratPernyataanDukungan,
    meta: {
      title: "Surat Pernyataan Dukungan - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
    children: [
      {
        path: "",
        name: "printFormSuratPernyataanDukungan",
        components: {
          default: DashboardPage,
          sidebar: SideBar,
        },
      },
    ],
  },
  {
    path: "/formSuratPernyataanKebenaranDokumen",
    component: FormSuratPernyataanKebenaranDokumen,
    meta: {
      title: "Surat Pernyataan Kebenaran Dokumen - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/formSuratPernyataanDukungan",
    component: FormSuratPernyataanDukungan,
    meta: {
      title: "Surat Pernyataan Dukungan - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/imkp",
    component: ImkpPage,
    meta: {
      title: "IMKP - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/approval-imkp",
    component: ApprovalImkpPage,
    meta: {
      title: "Approval IMKP - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.OHS,
        levelEnum.ADMIN,
        levelEnum.ENVIRONMENT,
        levelEnum.REPORTER,
        levelEnum.ISAFE,
      ],
    },
  },
  {
    path: "/imkp/:id",
    component: DetailImkpPage,
    meta: {
      title: "Detail IMKP - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.KONTRAKTOR,
        levelEnum.OHS,
        levelEnum.ADMIN,
        levelEnum.ENVIRONMENT,
        levelEnum.REPORTER,
        levelEnum.ISAFE,
      ],
    },
  },
  {
    path: "/form1View/:id",
    component: Form1View,
    meta: {
      title: "Form 1 View - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/form2View/:id",
    component: Form2View,
    meta: {
      title: "Form 2 View - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/form3View/:id/:kontraktorid",
    component: Form3View,
    meta: {
      title: "Form 3 View - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/form4View/:id/:kontraktorid",
    component: Form4View,
    meta: {
      title: "Form 4 View - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/form5View/:id/:kontraktorid",
    component: Form5View,
    meta: {
      title: "Form 5 View - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/lihatDokumenSIO/:id/:kontraktorid",
    component: lihatDokumenSIO,
    meta: {
      title: "Dokumen CoC - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/printDokumenSIO/:id/:kontraktorid",
    component: printDokumenSIO,
    meta: {
      title: "Print Dokumen CoC - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
    children: [
      {
        path: "",
        name: " ",
        components: {
          default: DashboardPage,
          sidebar: SideBar,
        },
      },
    ],
  },
  // {
  //   path: "/printDokumenForm1/:id",
  //   component: printDokumenForm1,
  //   meta: {
  //     title: "Print Dokumen Form 1 - Sini Saja",
  //     requiresAuth: true,
  //     access: [levelEnum.ISAFE, levelEnum.ADMIN, levelEnum.KONTRAKTOR],
  //   },
  // },
  // {
  //   path: "/printDokumenForm2/:id",
  //   component: printDokumenForm2,
  //   meta: {
  //     title: "Print Dokumen Form 2 - Sini Saja",
  //     requiresAuth: true,
  //     access: [levelEnum.ISAFE, levelEnum.ADMIN, levelEnum.KONTRAKTOR],
  //   },
  // },
  {
    path: "/approval-sio/penjadwalan-presentasi/:id/:kontraktorid", // add jadwal
    component: PenjadwalanPresentasi,
    meta: {
      title: "Penjadwalan Presentasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/approval-sio/penjadwalan-presentasi/:id/:kontraktorid/:idpenjadwalan", // edit jadwal
    component: PenjadwalanPresentasi,
    meta: {
      title: "Penjadwalan Presentasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/approval-sio/penilaian-presentasi/:id/:kontraktorid/:idpenjadwalan",
    component: PenilaianPresentasi,
    meta: {
      title: "Penilaian Presentasi - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/approval-sio/surat-pengesahan/:id/:kontraktorId", // surat pengesahan penunjukan PJO
    component: FormSuratPengesahanPenunjukanPJO,
    meta: {
      title: "Surat Pengesahan Penunjukan PJO - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/resumePenilaian/:idpenjadwalan",
    component: ResumePenilaian,
    meta: {
      title: "Resume Penilaian - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/historyPenilaian/:id",
    component: historyPenilaian,
    meta: {
      title: "History Penilaian - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/penilaian-pjo/nc-presentasi",
    component: PresentasiPjoNC,
    meta: {
      title: "NC Presentasi PJO - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/nc/:kontraktorId/:idpenjadwalan",
    component: NCPage,
    meta: {
      title: "NC Presntasi - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/pengajuan-baru-report",
    component: ReportSioPage,
    meta: {
      title: "Approval Report CoC - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.REPORTER,
        levelEnum.OHS,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
      ],
    },
  },
  {
    path: "/pergantian-sio-report",
    component: ReportSioPage,
    meta: {
      title: "Pergantian CoC Report - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.REPORTER,
        levelEnum.OHS,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
      ],
    },
  },
  {
    path: "/update-data-report",
    component: ReportSioPage,
    meta: {
      title: "Update Data CoC Report - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.REPORTER,
        levelEnum.OHS,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
      ],
    },
  },
  {
    path: "/profileKontraktorPreview/:id",
    component: ProfileKontraktorPreviewPage,
    meta: {
      title: "Profile Kontraktor Preview - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/verifikasi-data-imkp/:id",
    component: VerifikasiDataImkpPage,
    meta: {
      title: "Verifikasi Data IMKP - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.OHS,
        levelEnum.ADMIN,
        levelEnum.ENVIRONMENT,
        levelEnum.REPORTER,
        levelEnum.ISAFE,
      ],
    },
  },
  {
    path: "/amandemen-data-imkp/:id",
    component: VerifikasiDataImkpPage,
    meta: {
      title: "Amandemen Data IMKP - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.OHS,
        levelEnum.ADMIN,
        levelEnum.ENVIRONMENT,
        levelEnum.REPORTER,
        levelEnum.ISAFE,
      ],
    },
  },
  {
    path: "/preview-imkp/:id",
    component: PreviewImkpPage,
    meta: {
      title: "Preview IMKP - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.OHS,
        levelEnum.ADMIN,
        levelEnum.ENVIRONMENT,
        levelEnum.REPORTER,
        levelEnum.ISAFE,
      ],
    },
  },
  {
    path: "/maintenance",
    name: "MaintenancePage",
    component: MaintenancePage,
    meta: {
      title: "Maintenance - Sini Saja",
      requiresAuth: false,
    },
  },

  // GSF
  {
    path: "/dashboard-esg",
    component: DashboardPageEsg,
    meta: {
      title: "Dashboard ESG - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT, levelEnum.IMPROVEMENT],
    },
  },
  {
    path: "/dashboard-esg/:type/:workArea",
    component: DetailDashboardEsgPage,
    meta: {
      title: "Detail Dashboard ESG - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT, levelEnum.IMPROVEMENT],
    },
  },

  // New Template
  {
    path: "/esg-report",
    component: EsgReportPage,
    meta: {
      title: "ESG Report - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ENVIRONMENT,
        levelEnum.KONTRAKTOR,
        levelEnum.IMPROVEMENT,
      ],
    },
  },
  {
    path: "/esg-report/:year/:id_month/:workArea",
    component: EsgDetailPage,
    meta: {
      title: "ESG Detail Report - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/esg-report/:year/:id_month/:workArea/:id",
    component: EsgDetailPage,
    meta: {
      title: "ESG Detail Report - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ENVIRONMENT,
        levelEnum.KONTRAKTOR,
        levelEnum.IMPROVEMENT,
      ],
    },
  },
  {
    path: "/esg-report/:year/:id_month/:workArea/:id/:main_contractor_name/:id_contractor",
    component: EsgDetailPage,
    meta: {
      title: "ESG Detail Report - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/esg-report/:year/:id_month/:workArea/:id/:main_contractor_name/:id_contractor/:id_sub",
    component: EsgDetailPage,
    meta: {
      title: "ESG Detail Report - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ENVIRONMENT,
        levelEnum.KONTRAKTOR,
        levelEnum.IMPROVEMENT,
      ],
    },
  },
  {
    path: "/master-data/type/fuel",
    component: MasterDataFuelPage,
    meta: {
      title: "MD Bahan Bakar - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT],
    },
  },
  {
    path: "/master-data/type/elektrifikasi",
    component: MasterDataElectricPage,
    meta: {
      title: "MD Elektrifikasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT],
    },
  },
  {
    path: "/master-data/type/renewable",
    component: MasterDataRenewableEnergyPage,
    meta: {
      title: "MD Energi Terbarukan - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT],
    },
  },
  {
    path: "/master-data/power-available",
    component: MasterDataPowerAvailablePage,
    meta: {
      title: "MD Daya Tersedia - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT],
    },
  },
  {
    path: "/setting",
    component: SettingPage,
    meta: {
      title: "Setting ESG - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ENVIRONMENT],
    },
  },
  {
    path: "/master-data/user-contractor",
    component: () =>
      import(
        "@/pages/master-data/user-contractor/MasterDataUserContractorPage.vue"
      ),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/user-internal",
    component: () =>
      import(
        "@/pages/master-data/user-internal/MasterDataUserInternalPage.vue"
      ),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/user-external",
    component: () =>
      import(
        "@/pages/master-data/user-external/MasterDataUserExternalPage.vue"
      ),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/classification",
    component: () =>
      import(
        "@/pages/master-data/classification/MasterDataClassificationPage.vue"
      ),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/element",
    component: () =>
      import("@/pages/master-data/element/MasterDataElementPage.vue"),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/aspect-evaluation",
    component: () =>
      import(
        "@/pages/master-data/aspect-evaluation/MasterDataAspectEvaluationPage.vue"
      ),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/aspect-evaluation-detail",
    component: () =>
      import(
        "@/pages/master-data/aspect-evaluation/MasterDataAspectEvaluationDetilPage.vue"
      ),
    meta: {
      title: "Master Data - Aspek Evaluasi Detail NC - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/aspect-evaluation-detail/:id",
    name: "MasterDataAspectEvaluationDetilFormPage",
    component: () =>
      import(
        "@/pages/master-data/aspect-evaluation/MasterDataAspectEvaluationDetilFormPage.vue"
      ),
    meta: {
      title: "Aspek Evaluasi Detail NC - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/aspect-evaluation-pinalty",
    component: () =>
      import(
        "@/pages/master-data/aspect-evaluation/MasterDataAspectEvaluationPinaltyPage.vue"
      ),
    meta: {
      title: "Master Data - Aspek Evaluasi Pinalty - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/master-data/clause",
    component: () =>
      import("@/pages/master-data/clause/MasterDataClausePage.vue"),
    meta: {
      title: "Master Data - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  // {
  //   path: "/nc-smkp-report",
  //   component: () => import("@/pages/nc-smkp/NCSmkpReportPage.vue"),
  //   meta: {
  //     title: "NC SMKP - Sini Saja",
  //     requiresAuth: true,
  //     access: [
  //       levelEnum.ADMIN,
  //       levelEnum.OHS,
  //       levelEnum.ENVIRONMENT,
  //       levelEnum.IMPROVEMENT,
  //       levelEnum.ISAFE,
  //       levelEnum.REPORTER,
  //     ],
  //   },
  // },
  // {
  //   path: "/nc-smkp-monitoring",
  //   component: () => import("@/pages/nc-smkp/NCSmkpMonitoringPage.vue"),
  //   meta: {
  //     title: "NC SMKP Monitoring - Sini Saja",
  //     requiresAuth: true,
  //     access: [levelEnum.ADMIN],
  //   },
  // },
  // {
  //   path: "/nc-smkp-monitoring-audit",
  //   component: () => import("@/pages/nc-smkp/NCSmkpMonitoringAuditPage.vue"),
  //   meta: {
  //     title: "NC SMKP Monitoring - Sini Saja",
  //     requiresAuth: true,
  //     access: [
  //       levelEnum.OHS,
  //       levelEnum.ENVIRONMENT,
  //       levelEnum.IMPROVEMENT,
  //       levelEnum.ISAFE,
  //       levelEnum.REPORTER,
  //     ],
  //   },
  // },
  // {
  //   path: "/nc-smkp-report/:id",
  //   component: () => import("@/pages/nc-smkp/NCSmkpDetilPage.vue"),
  //   meta: {
  //     title: "NC SMKP Detil - Sini Saja",
  //     requiresAuth: true,
  //     access: [
  //       levelEnum.ADMIN,
  //       levelEnum.OHS,
  //       levelEnum.ENVIRONMENT,
  //       levelEnum.IMPROVEMENT,
  //       levelEnum.ISAFE,
  //       levelEnum.REPORTER,
  //     ],
  //   },
  // },
  // {
  //   path: "/nc-smkp-report/:id/add-nc",
  //   component: () => import("@/pages/nc-smkp/NCCreatePage.vue"),
  //   meta: {
  //     title: "NC SMKP Detil - Sini Saja",
  //     requiresAuth: true,
  //     access: [
  //       levelEnum.ADMIN,
  //       levelEnum.OHS,
  //       levelEnum.ENVIRONMENT,
  //       levelEnum.IMPROVEMENT,
  //     ],
  //   },
  // },
  // {
  //   path: "/nc-smkp-report/:id/upload-fu/:ncId",
  //   component: () => import("@/pages/nc-smkp/NCUploadEvidencePage.vue"),
  //   meta: {
  //     title: "NC Upload Bukti - Sini Saja",
  //     requiresAuth: true,
  //     access: [
  //       levelEnum.ADMIN,
  //       levelEnum.OHS,
  //       levelEnum.ENVIRONMENT,
  //       levelEnum.IMPROVEMENT,
  //       levelEnum.ISAFE,
  //       levelEnum.REPORTER,
  //     ],
  //   },
  // },
  // {
  //   path: "/nc-smkp-monitoring/:ncId",
  //   component: () => import("@/pages/nc-smkp/NCReviewEvidencePage.vue"),
  //   meta: {
  //     title: "NC Review Bukti - Sini Saja",
  //     requiresAuth: true,
  //     access: [
  //       levelEnum.ADMIN,
  //       levelEnum.OHS,
  //       levelEnum.ENVIRONMENT,
  //       levelEnum.IMPROVEMENT,
  //       levelEnum.ISAFE,
  //       levelEnum.REPORTER,
  //     ],
  //   },
  // },
  {
    path: "/evaluation-dashboard",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPDashboardPage.vue"),
    meta: {
      title: "Evaluasi Dashboard - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/evaluation-dashboard/detil",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPDashboardDetilPage.vue"),
    meta: {
      title: "Evaluasi Dashboard Detil - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/evaluation-report",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPReportPage.vue"),
    meta: {
      title: "Evaluasi - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/evaluation-report/add",
    component: () => import("@/pages/evaluation-pjp/EvaluationPJPFormPage.vue"),
    meta: {
      title: "Add Evaluasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/evaluation-report/:id",
    component: () => import("@/pages/evaluation-pjp/EvaluationPJPFormPage.vue"),
    meta: {
      title: "Edit Evaluasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/evaluation-report/nc-pjp/:id",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPDetilPage.vue"),
    meta: {
      title: "Evaluasi Detil - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/evaluation-report/nc-pjp/:id/add-nc",
    component: () => import("@/pages/evaluation-pjp/NCCreatePage.vue"),
    meta: {
      title: "Evaluasi Detil - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/evaluation-report/nc-pjp/:id/upload-fu/:ncId",
    component: () => import("@/pages/evaluation-pjp/NCUploadEvidencePage.vue"),
    meta: {
      title: "Evaluasi Detil - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN, levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/evaluation-report/self-assessment/:id",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPSelfAssessmentPage.vue"),
    meta: {
      title: "Self Assessment Form - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN, levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/evaluation-report/summary-assessment/:id",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPSummaryAssessmentPage.vue"),
    meta: {
      title: "Summary Assessment Form - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/evaluation-report/summary-penilaian/:id",
    component: () =>
      import(
        "@/pages/evaluation-pjp/EvaluationPJPSummaryAssessmentContractorPage.vue"
      ),
    meta: {
      title: "Summary Penilaian PJP - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/evaluation-report/summary-nc/:id",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPSummaryNCPage.vue"),
    meta: {
      title: "Summary NC - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/evaluation-report/assessment-aspect/mitra/:id/:aspectId",
    component: () =>
      import(
        "@/pages/evaluation-pjp/EvaluationPJPAssessmentAspectMitraPage.vue"
      ),
    meta: {
      title: "Aspek Evaluasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN, levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/evaluation-report/assessment-aspect/evaluator/:id/:aspectId",
    component: () =>
      import(
        "@/pages/evaluation-pjp/EvaluationPJPAssessmentAspectEvaluatorPage.vue"
      ),
    meta: {
      title: "Aspek Evaluasi - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/evaluation-report/assessment-aspect/admin/:id/:aspectId",
    component: () =>
      import(
        "@/pages/evaluation-pjp/EvaluationPJPAssessmentAspectAdminPage.vue"
      ),
    meta: {
      title: "Aspek Evaluasi - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN, levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/evaluation-report/release-nc/:id/:aspectId",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPReleaseNCFormPage.vue"),
    meta: {
      title: "Release NC Form - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.ADMIN],
    },
  },
  {
    path: "/evaluation-report/evaluator-assessment/:id",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPEvaluatorAssessmentPage.vue"),
    meta: {
      title: "Evaluasi Penilaian - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/evaluation-monitoring",
    component: () =>
      import("@/pages/evaluation-pjp/EvaluationPJPMonitoringPage.vue"),
    meta: {
      title: "Evaluation Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/evaluation-monitoring/:ncId",
    component: () => import("@/pages/evaluation-pjp/NCReviewEvidencePage.vue"),
    meta: {
      title: "NC Review Bukti - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/evaluation-monitoring/detil/:type",
    component: () =>
      import("@/pages/evaluation-pjp/DetilEvaluationPJPMonitoringPage.vue"),
    meta: {
      title: "Detil Evaluation Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
    beforeEnter: (to, from, next) => {
      const validTypes = ["area", "aspect"];
      if (validTypes.includes(to.params.type)) {
        next();
      } else {
        // Redirect to default or show error
        next({ path: "/evaluation-monitoring" });
      }
    },
  },
  /*
  {
    path: "/nc-smkp-mitra-report",
    component: () => import("@/pages/nc-smkp-mitra/NCSmkpMitraReportPage.vue"),
    meta: {
      title: "NC SMKP Mitra - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/nc-smkp-mitra-report/:id",
    component: () => import("@/pages/nc-smkp-mitra/NCSmkpMitraDetilPage.vue"),
    meta: {
      title: "NC SMKP Mitra Detil - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/nc-smkp-mitra-report/:id/add-nc",
    component: () => import("@/pages/nc-smkp-mitra/NCCreatePage.vue"),
    meta: {
      title: "NC SMKP Mitra - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/nc-smkp-mitra-report/:id/upload-fu/:ncId",
    component: () => import("@/pages/nc-smkp-mitra/NCUploadEvidencePage.vue"),
    meta: {
      title: "NC SMKP Mitra - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.KONTRAKTOR,
      ],
    },
  },
  {
    path: "/nc-smkp-mitra-monitoring",
    component: () =>
      import("@/pages/nc-smkp-mitra/NCSmkpMitraMonitoringPage.vue"),
    meta: {
      title: "NC SMKP Mitra Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-smkp-mitra-monitoring/detil",
    component: () =>
      import("@/pages/nc-smkp-mitra/DetilNCSmkpMitraMonitoringPage.vue"),
    meta: {
      title: "NC SMKP Mitra Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  // {
  //   path: "/nc-smkp-mitra-monitoring-pjo",
  //   component: () =>
  //     import("@/pages/nc-smkp-mitra/NCSmkpMitraMonitoringPjoPage.vue"),
  //   meta: {
  //     title: "NC SMKP Mitra Monitoring - Sini Saja",
  //     requiresAuth: true,
  //     access: [levelEnum.KONTRAKTOR, levelEnum.ADMIN],
  //   },
  // },
  {
    path: "/nc-smkp-mitra-monitoring-mitra",
    component: () =>
      import("@/pages/nc-smkp-mitra/NCSmkpMitraMonitoringMitraPage.vue"),
    meta: {
      title: "NC SMKP Mitra Monitoring - Sini Saja",
      requiresAuth: true,
      access: [levelEnum.KONTRAKTOR],
    },
  },
  {
    path: "/nc-smkp-mitra-monitoring/:ncId",
    component: () => import("@/pages/nc-smkp-mitra/NCReviewEvidencePage.vue"),
    meta: {
      title: "NC SMKP Mitra Monitoring Detil - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  */
  {
    path: "/nc-audit-iso-smk3-internal",
    component: () => import("@/pages/iso-internal/ISOInternalReportPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (Internal) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-internal/:id",
    component: () => import("@/pages/iso-internal/ISOInternalDetilPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (Internal) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-internal/:id/add-nc",
    component: () => import("@/pages/iso-internal/CreateNCPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (Internal) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-internal/:id/upload-fu/:ncId",
    component: () => import("@/pages/iso-internal/UploadEvidanceNCPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (Internal) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-internal-monitoring",
    component: () =>
      import("@/pages/iso-internal/ISOInternalMonitoringPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (Internal) Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-internal-monitoring/:ncId",
    component: () => import("@/pages/iso-internal/ReviewEvidenceNCPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (Internal) Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-external",
    component: () => import("@/pages/iso-external/ISOExternalReportPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (External) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-external/:id",
    component: () => import("@/pages/iso-external/ISOExternalDetilPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (External) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-external/:id/add-nc",
    component: () => import("@/pages/iso-external/CreateNCPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (External) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-external/:id/upload-fu/:ncId",
    component: () => import("@/pages/iso-external/UploadEvidanceNCPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (External) - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-external-monitoring",
    component: () =>
      import("@/pages/iso-external/ISOExternalMonitoringPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (External) Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.EXTERNAL,
      ],
    },
  },
  {
    path: "/nc-audit-iso-smk3-external-monitoring/:ncId",
    component: () => import("@/pages/iso-external/ReviewEvidenceNCPage.vue"),
    meta: {
      title: "NC Audit ISO & SMK3 (External) Monitoring - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.OHS,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.ISAFE,
        levelEnum.REPORTER,
        levelEnum.EXTERNAL,
      ],
    },
  },
];

const routePenilaian = [
  { path: "/aspek-materi/:idaspek", component: materiAspek },
  {
    path: "/materi/aspek-teknik-operasional",
    component: materiAspekTeknikOperasional,
  },
  {
    path: "/materi/aspek-keselamatan-pertambangan",
    component: materiAspekKeselamatanPertambangan,
  },
  { path: "/materi/aspek-smkp", component: materiAspekSmkp },
  {
    path: "/materi/aspek-pengelolaan-lingkungan-hidup",
    component: materiAspekPengelolaanLingkunganHidup,
  },
  { path: "/materi/aspek-konservasi", component: materiAspekKonservasi },
  {
    path: "/materi/aspek-standarisasi-usaha-jaya",
    component: materiAspekStandarisasiUsahaJaya,
  },
  { path: "/materi/aspek-improvement", component: materiAspekImprovement },
  { path: "/materi/aspek-teknis", component: materiAspekImprovement },

  { path: "/aspek-teknis/:idaspek", component: teknisAspek },
  {
    path: "/teknis/aspek-teknik-operasional",
    component: teknisAspekTeknikOperasional,
  },
  {
    path: "/teknis/aspek-keselamatan-pertambangan",
    component: teknisAspekKeselamatanPertambangan,
  },
  { path: "/teknis/aspek-smkp", component: teknisAspekSmkp },
  {
    path: "/teknis/aspek-pengelolaan-lingkungan-hidup",
    component: teknisAspekPengelolaanLingkunganHidup,
  },
  { path: "/teknis/aspek-konservasi", component: teknisAspekKonservasi },
  {
    path: "/teknis/aspek-standarisasi-usaha-jaya",
    component: teknisAspekStandarisasiUsahaJaya,
  },
  { path: "/teknis/aspek-improvement", component: teknisAspekImprovement },
];

routePenilaian.forEach((val) => {
  // console.log(val);
  routes.push({
    path:
      "/approval-sio/penilaian-presentasi/:id/:kontraktorid/:idpenjadwalan" +
      val.path,
    component: val.component,
    meta: {
      title: "Penilaian Presentasi - Sini Saja",
      requiresAuth: true,
      access: [
        levelEnum.ADMIN,
        levelEnum.ISAFE,
        levelEnum.ENVIRONMENT,
        levelEnum.IMPROVEMENT,
        levelEnum.OHS,
        levelEnum.REPORTER,
      ],
    },
  });
});

// Catch-all route for undefined routes
routes.push({
  path: "/:catchAll(.*)",
  redirect: () => {
    const user = checkSession();
    if (user) {
      return getDefaultRouteForRole(resolveUserRoleFromSession(user));
    }
    return "/login";
  },
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const user = checkSession();
  const userRole = resolveUserRoleFromSession(user);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!user) {
      next({ path: "/login" });
      return;
    }

    // const routeAccess = to.matched
    //   .map((record) => record.meta.access)
    //   .filter(Boolean)
    //   .pop();

    // if (!canAccessRoute(userRole, routeAccess)) {
    //   next({ path: getDefaultRouteForRole(userRole) });
    //   return;
    // }

    next();
    return;
  }

  if (user && to.path.startsWith("/login")) {
    next({ path: getDefaultRouteForRole(userRole) });
    return;
  }

  next();
});

router.afterEach((to) => {
  document.title = to.meta.title || "Sini Saja";
});

function checkSession() {
  const user = JSON.parse(localStorage.getItem("user_cms"));
  return user;
}

export default router;
